<template>
  <v-text-field v-money="money" @input="onChange" v-model="data">
    <template slot="label"><span v-html="label"/></template>
  </v-text-field>
</template>

<script>
export default {
  props: ["value", "label"],
  data() {
    return {
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$ ",
        suffix: "",
        precision: 0,
        masked: false,
        allowNegative: false
      },
      data: null,
      frmReady: false
    };
  },
  methods: {
    onChange() {    
       if (parseFloat(this.data) < 0)  {
        this.data = '0';
       }
      let v = this.data + "";
      v = v.replace('$ ', "");
      v = v.replace(/,/g, "");
      this.$emit("input", v);
    }
  },  
  created() {
   
  },  
  mounted(){
    
  },
  watch: {
    "value":{
      handler(n,o){               
          if(n==undefined){
            this.data = Number(0);
            return;
          }    
          this.data =Number( n );
        
      },immediate:true, deep:false
    }    
  },

};
</script> 